import Row from "antd/lib/grid/row";
import Typography from "antd/lib/typography";
import { Category, difficultyNameFemale } from "../../models/gameModels";
import { sizes } from "../../styles/sizes";

const CompletedRow = ({ group }: { group: Category }) => {
  return (
    <Row
      tabIndex={0}
      aria-label={`קבוצה ${difficultyNameFemale[group.difficulty]}: ${group.name}: ${group.words.join(",")}`}
      aria-live={"polite"}
      style={{
        height: sizes.wordHeight,
        width: sizes.completedRowWidth,
        marginLeft: 0,
        marginRight: 0,
        lineHeight: 1,
        borderRadius: "8px",
        textAlign: "center",
        justifyContent: "center",
        color: "black",
        backgroundColor: difficultyColor(group.difficulty),
        animation: "popIn 0.2s ease forwards",
        flexDirection: "column",
      }}
    >
      <div aria-hidden={true}>
        <div style={{}}>
          <Typography.Text
            aria-hidden={"true"}
            style={{
              color: "black",
              fontFamily: "arial",
              fontSize: "21px",
              lineHeight: "1em",
              fontWeight: "800",
              textTransform: "uppercase",
            }}
          >
            {group.name}
          </Typography.Text>
        </div>
        <div style={{}} aria-hidden={"true"}>
          <Typography.Text
            style={{
              color: "black",
              fontFamily: "arial",
              fontSize: "19px",
              lineHeight: "1em",
              textTransform: "uppercase",
            }}
          >
            {group.words.join(", ")}
          </Typography.Text>
        </div>
      </div>
    </Row>
  );
};
const difficultyColor = (difficulty: 1 | 2 | 3 | 4): string => {
  return {
    1: "#fbd400",
    2: "#b5e352",
    3: "#729eeb",
    4: "#bc70c4",
  }[difficulty];
};

export default CompletedRow;
